module.exports = __webpack_public_path__ + "static/img/wheelBgBonus.04f989b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/wheelBgBonus.png
// module id = iT4S
// module chunks = 0